<h3 class="heading">{{ heading }}</h3>
<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions" style="width: 100%; height: 400px; display: block;"
></highcharts-chart>

